import React from "react"
import ReactDOM from "react-dom"
import { I18nextProvider } from "react-i18next"
import { ThemeProvider } from "@mui/material/styles"
import App from "./App"
import i18n from "./i18n"
import theme from "./theme"

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </I18nextProvider>,
  document.getElementById("root")
)
